<template>
  <v-card flat>
    <v-tabs v-model="tab" centered>
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#projets">
        Projets
      </v-tab>

      <v-tab href="#regions">
        régions
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="projets">
        <v-card flat>
          <v-card-text>
            Total groupes ayant bénéficié des projets:
            {{
              _.sumBy(Projets, function (o) {
                return o.nbreGroupe;
              })
            }}
          </v-card-text>
          <v-card-text>
            <v-data-table
              hide-default-footer
              :items-per-page="100"
              :headers="headersProjet"
              :items="Projets"
            >
              <template v-slot:item.nombre="{ item }">
                {{ item.nbreGroupe }}
              </template>
              <template v-slot:item.date="{ item }">
                {{ $moment(item.dateStatGroupe).format("DD-MM-YYYY HH:mm:ss") }}
              </template>
              <template v-slot:item.actions="{ item }">
                <loadGroupesDeProjet
                  :projet="item"
                  @updateProjet="getProjets()"
                />
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="regions">
        <v-card flat>
          <v-card-text>
            Total Groupes actifs:
            {{
              _.sumBy(Regions, function (o) {
                return o.nbreGroupe;
              })
            }}
          </v-card-text>
          <v-card-text>
            <v-data-table
              hide-default-footer
              :items-per-page="100"
              :headers="headers"
              :items="Regions"
            >
              <template v-slot:item.nombre="{ item }">
                {{ item.nbreGroupe }}
              </template>
              <template v-slot:item.date="{ item }">
                {{ $moment(item.dateStatGroupe).format("DD-MM-YYYY HH:mm:ss") }}
              </template>
              <template v-slot:item.actions="{ item }">
                <loadGroupesDeRegion
                  :region="item"
                  @updateRegion="GetRegions()"
                />
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    loadGroupesDeProjet: require("@/components/stats/loadGroupesDeProjet.vue")
      .default,
    loadGroupesDeRegion: require("@/components/stats/loadGroupesDeRegion.vue")
      .default,
  },
  data() {
    return {
      tab: "projets",
      headers: [
        {
          text: "Region",
          align: "start",

          value: "ll_region",
        },
        { text: "Date", value: "date", sortable: false },
        { text: "Nombre", value: "nombre", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
      headersProjet: [
        {
          text: "Projet",
          align: "start",
          value: "ll_programme",
        },
        { text: "Date", value: "date", sortable: false },
        { text: "Nombre", value: "nombre", sortable: false },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      Regions: (state) => state.Regions.Regions,
      Projets: (state) => state.Projets.projets,
    }),
  },
  methods: {
    ...mapActions({
      getBailleurs: "Bailleurs/getListeBailleurs",
      getProjets: "Projets/getListeProjets",
      GetAllGroupeRequest: "Groupes/GetAllGroupeRequest",
      GetAllCounts: "Counts/GetAll",
      GetAllTypeDetails: "TypeDetailEtape/GetAll",
      GetAllRolesHorsGroupe: "RolesHorsGroupe/GetAll",
      GetRegions: "Regions/GetAll",
      GetProvinces: "Provinces/GetAll",
    }),
  },
};
</script>

<style scoped></style>
